
import { defineComponent } from "vue";
import Decrement from "../icons/Decrement.vue";
import Increment from "../icons/Increment.vue";

export default defineComponent({
  components: {
    Decrement, Increment,
  },
  props: {
    modelValue: { type: Number, required: true },
    block: { type: Boolean, default: false },
    min: { type: Number, default: 0 },
    max: { type: Number, default: Infinity },
  },
  emits: [
    "update:modelValue",
  ],
  methods: {
    onChange(value: string): void {
      const number = Number(value);
      if (!Number.isNaN(number)) {
        this.$emit("update:modelValue", Math.min(this.max, Math.max(this.min, number)));
      }
    },
  },
});
